import { render } from "./AccessCode.vue?vue&type=template&id=27082392"
import script from "./AccessCode.vue?vue&type=script&lang=js"
export * from "./AccessCode.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__